<template>
  <div v-if="loader" class="loader">{{ loading[lang] }}</div>
  <div v-else class="archivbestaende">
    <!-- <h3>{{ archive_collections[lang] }}</h3> -->
    <div class="controls mt-3">
      <button @click="toggleAll">{{ expandButton[expandButton.state][lang] }}</button>
    </div>
    <ul>
      <li v-for="(cities, county, idx) in archivbestandObjekts" @click="toggleOpen($event)"
        :key="'archivbestand_county' + idx">{{ county }}
        <ul>
          <li v-for="(institutions, city, idx) in cities" @click="toggleOpen($event)"
            :key="'archivbestand_city' + idx" class="city">
            <span class="city-name" v-html="city ? city : 'Stadt unbekannt'"></span>
            <ul>
              <li v-for="(archives, institution) in institutions">{{ institution }}
                <ul>
                  <!-- <template v-for="archive in archives">
                    <li :key="'archivbestand_institution' + archive.id" class="institution" v-if="archive.Archiv___Bestand">
                      <span v-if="archive.Archiv___Bestand">Bestand: {{ archive.Archiv___Bestand }}</span><span v-if="archive.Archiv___Bestand && archive.Archiv___Akten">, </span>
                      <span v-if="archive.Archiv___Akten">Akten: {{ archive.Archiv___Akten }}</span>
                    </li>
                  </template> -->
                  <li v-for="archive in archives" :id="'archive-' + archive.id" :key="'archivbestand_institution' + archive.id" :class="'institution' + (archive.Archiv___Bestand ? '' : ' d-none')">
                    <span v-if="archive.Archiv___Bestand">{{ collection[lang] }}: {{ archive.Archiv___Bestand }}</span><span v-if="!archive.Archiv___Bestand" class="missing"><a :href="'https://www.mari-portal.de/omeka/admin/items/edit/' + archive.id" target="_blank">Archivbestand fehlt</a><span v-if="archive.Sigle" class="small"> (Sigle: {{ archive.Sigle }})</span></span><span v-if="archive.Archiv___Bestand && archive.Archiv___Akten">, </span>
                    <span v-if="archive.Archiv___Akten">{{ files[lang] }}: {{ archive.Archiv___Akten }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <!-- <pre>{{ archivbestandObjekts }}</pre> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    lang: {
      type: String
    }
  },
  data () {
    return {
      expanded: false,
      expandButton: {
        state: 'expand',
        expand: {
          de: 'Alle ausklappen',
          en: 'Expand all'
        },
        collapse: {
          de: 'Alle einklappen',
          en: 'Collapse all'
        }
      },
      archive_collections: {
        de: 'Archivbestände',
        en: 'Archive collections'
      },
      loading: {
        de: 'Lade Archivbestand ...',
        en: 'Loading archive collection ...'
      },
      collection: {
        de: 'Bestand',
        en: 'Collection'
      },
      files: {
        de: 'Akten',
        en: 'Files'
      }
    }
  },
  methods: {
    ...mapActions(['fetchArchivbestandObjekts']),
    toggleOpen (event) {
      event.stopPropagation()
      const ul = event.target.querySelector('ul')
      if (ul) {
        event.target.classList.toggle('open')
        ul.classList.toggle('open')
      }
    },
    toggleAll () {
      this.expanded = !this.expanded
      this.expandButton.state = this.expanded ? 'collapse' : 'expand'
      document.querySelectorAll('.archivbestaende li').forEach(li => {
        const ul = li.querySelector('ul')
        if (ul) {
          li.classList.toggle('open', this.expanded)
          ul.classList.toggle('open', this.expanded)
        }
      })
    }
  },
  computed: {
    ...mapGetters(['loader', 'translate', 'archivbestandObjekts'])
  },
  mounted () {
    this.fetchArchivbestandObjekts()
  }
}
</script>
<style lang="scss" scoped>
.archivbestaende {
  margin-bottom: 2rem;
  .controls {
    display: flex;
    align-items: center;
    // justify-content: flex-end;
    margin-bottom: 1rem;
    button {
      padding: 0.25rem 0.5rem;
      background-color: #6928ff;
      border: 1px solid #570fff;
      border-radius: 0.375rem;
      color: #fff;
      cursor: pointer;
      &:hover {
        background-color: #7539ff;
        border: 1px solid #540aff;
        color: #fff;
      }
    }
  }
  .missing {
    a {
      color: red;
    }
  }
  ul {
    // width: fit-content;
    width: 100%;
    list-style: none;
    margin: 0;
    margin-left: 0.5rem;
    padding-left: 1rem;
    list-style-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%236928ff' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm4.5 5.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z'/%3E%3C/svg%3E");
    li {
      // width: fit-content;
      width: 100%;
      cursor: pointer;
      &.open {
        list-style-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='%236928ff' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 2.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z'/%3E%3C/svg%3E");
      }
      ul {
        display: none;
        &.open {
          display: block;
        }
        .city-name {
          pointer-events: none;
        }
        ul ul,
        ul ul.open {
          list-style-image: url("data:image/svg+xml,%3Csvg width='16' height='18' fill='%23000000' viewBox='0 0 16 18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M 14.5,7 A 0.5,0.5 0 0 1 15,7.5 v 9 A 0.5,0.5 0 0 1 14.5,17 H 1.5 A 0.5,0.5 0 0 1 1,16.5 v -9 A 0.5,0.5 0 0 1 1.5,7 Z M 1.5,6 A 1.5,1.5 0 0 0 0,7.5 v 9 A 1.5,1.5 0 0 0 1.5,18 h 13 A 1.5,1.5 0 0 0 16,16.5 v -9 A 1.5,1.5 0 0 0 14.5,6 Z' /%3E%3Cpath d='M 3,9.5 A 0.5,0.5 0 0 1 3.5,9 h 9 a 0.5,0.5 0 0 1 0,1 h -9 A 0.5,0.5 0 0 1 3,9.5 M 3,12 a 0.5,0.5 0 0 1 0.5,-0.5 h 9 a 0.5,0.5 0 0 1 0,1 h -9 A 0.5,0.5 0 0 1 3,12 m 0,2.5 A 0.5,0.5 0 0 1 3.5,14 h 6 a 0.5,0.5 0 0 1 0,1 h -6 A 0.5,0.5 0 0 1 3,14.5' /%3E%3C/svg%3E");
        }
      }
      li li li {
        cursor: initial;
        padding-right: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partials/Archivbestand.vue